import React, {
    useContext, useEffect, useCallback, useState
} from 'react';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from 'gw-portals-validation-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { useAuthentication } from 'gw-digital-auth-react';
import { ModalNextProvider } from '@jutro/components';
import Address from 'gw-capability-fnol-common-react/models/Address';
import { WizardPage, wizardProps, WizardPageTemplate } from 'gw-portals-wizard-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './RepairFacilityPage.metadata.json5';
import styles from './RepairFacilityPage.module.scss';
import messages from '../../FNOLCA.messages';

function FNOLCARepairFacilityPage(props) {
    const translator = useContext(TranslatorContext);
    const { AddressLookupService } = useDependencies('AddressLookupService');
    const { authHeader } = useAuthentication();
    const { wizardData: claimVM, updateWizardData } = props;
    const [showLookupResult_Ext, updateShowLookupResult_Ext] = useState(false);
    const [showPostCodeLoader, updateshowPostCodeLoader] = useState(false);
    const [lookupResult_Ext, updatelookupResult_Ext] = useState(null);
    const {
        isComponentValid,
        initialValidation,
        onValidate,
        registerInitialComponentValidation
    } = useValidation('RepairFacilityPage');

    useEffect(() => {
        const ownRepairOptionPath = 'lobs.commercialAuto.repairOption.ownRepairer';
        const repairOptionVIPath = 'lobs.commercialAuto.repairOption.vehicleIncident';
        const vehicleIncidentsPath = 'lobs.commercialAuto.vehicleIncidents';
        const vehicleIncidents = _.get(claimVM.value, vehicleIncidentsPath, []);

        if (_.isEmpty(claimVM.value.lobs.commercialAuto.repairOption.ownRepairer)) {
            _.set(claimVM.value, ownRepairOptionPath, {
                reasonForApproval: 'fleetProvider',
                nameOfOwnRepairer: null,
                noteForEngineer: null,
                address: new Address(),
                phoneNumber: null,
                emailAddress: null,
                userSkipsOwnRepairerDetails: false
            });
        }

        if (!_.get(claimVM.value, repairOptionVIPath) && vehicleIncidents.length === 1) {
            _.set(claimVM.value, repairOptionVIPath, vehicleIncidents[0]);
        } else if (!_.get(claimVM.value, repairOptionVIPath) && vehicleIncidents.length > 1) {
            _.set(claimVM.value, repairOptionVIPath,
                _.find(vehicleIncidents, (inc) => inc.vehicleLossParty_Ext === 'insured' && inc.driver != null));
        }
        updateWizardData(claimVM);
    }, []);

    const isPostCodeValid = () => {
        const newAddress = _.get(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.address');
        if (newAddress && newAddress.postalCode) {
            // eslint-disable-next-line max-len
            const postCodeRegex = /^(([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2}))$/;
            return !postCodeRegex.test(newAddress.postalCode);
        }
        return true;
    };

    const getMultipleLookupResult = useCallback(() => {
        const locationCodes = lookupResult_Ext && lookupResult_Ext.resultSummaries;
        if (locationCodes) {
            return locationCodes.map((locationCode) => {
                return {
                    code: locationCode.addressSummary,
                    name: locationCode.addressSummary
                };
            });
        }
        return [];
    }, [lookupResult_Ext]);

    const isUnitedKingdomChosen = () => {
        const newAddress = _.get(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.address');
        if (newAddress && newAddress.country) {
            return newAddress.country === 'GB';
        }
        return true;
    };

    const lookupClick = async () => {
        const newAddress = new Address();
        newAddress.postalCode = _.get(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.address.postalCode');
        await AddressLookupService.addressLookup(newAddress, authHeader)
            .then((lookupResult) => {
                // TODO Handle for multiple addresses
                /* if (!lookupResult.fetchRequired) {
                    _.set(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.address', lookupResult.address);
                } */
                if (lookupResult.fetchRequired) {
                    updatelookupResult_Ext(lookupResult);
                    updateShowLookupResult_Ext(true);
                } else {
                    updateShowLookupResult_Ext(false);
                    _.set(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.address', lookupResult.address);
                }
                updateWizardData(claimVM);
            }).catch(() => {
                ModalNextProvider.showAlert({
                    title: messages.postCodeLookupErrorTitle,
                    message: translator(messages.postCodeLookupErrorMessage),
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: messages.postCodeLookupErrorConfirmMessage
                }).catch(_.noop);
            });
    };

    const handlePostCodeAddressDropDownValueChange = useCallback(async (addressIndex) => {
        updateshowPostCodeLoader(true);
        const currentLocation = _.get(claimVM, 'lobs.commercialAuto.repairOption.ownRepairer.address');
        const updatedLocations = lookupResult_Ext.resultSummaries.find((location) => {
            return location.addressSummary === addressIndex;
        });
        const newAddress = new Address();
        newAddress.postalCode = currentLocation.postalCode.value;
        if (updatedLocations) {
            await AddressLookupService.getAddressFromLookup(updatedLocations, newAddress, authHeader)
                .then((lookupResult) => {
                    _.set(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.address', lookupResult);
                    updateWizardData(claimVM);
                    updateshowPostCodeLoader(false);
                    // updateShowLookupResult_Ext(false);
                }).catch(() => {
                    updateshowPostCodeLoader(false);
                    ModalNextProvider.showAlert({
                        title: messages.postCodeLookupErrorTitle,
                        message: translator(messages.postCodeLookupErrorMessage),
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: messages.postCodeLookupErrorConfirmMessage
                    }).catch(_.noop);
                });
        } else {
            updateshowPostCodeLoader(false);
            _.set(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.address', newAddress);
        }
    },
    [claimVM, authHeader, updateWizardData, AddressLookupService, translator, lookupResult_Ext]);

    const handleOwnRepairerSkip = () => {
        const ownRepairerSkipDetails = _.get(
            claimVM.value,
            'lobs.commercialAuto.repairOption.ownRepairer.userSkipsOwnRepairerDetails'
        );
        if (!ownRepairerSkipDetails) {
            _.set(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer', {
                reasonForApproval: null,
                nameOfOwnRepairer: null,
                noteForEngineer: null,
                address: new Address(),
                phoneNumber: null,
                emailAddress: null,
                userSkipsOwnRepairerDetails: true
            });
        } else {
            _.set(
                claimVM.value,
                'lobs.commercialAuto.repairOption.ownRepairer.userSkipsOwnRepairerDetails',
                false
            );
        }
        updateWizardData(claimVM);
    };

    const handleOwnRepairerValueChange = (value, path) => {
        const oldValue = _.get(claimVM.value, path);
        if (path === 'lobs.commercialAuto.repairOption.ownRepairer.reasonForApproval'
        && oldValue !== null
        && (value === 'newVehicle' && oldValue !== 'newVehicle')) {
            ModalNextProvider.showAlert({
                title: messages.ownRepairReasonChangePopupTitle,
                message: translator(messages.ownRepairReasonChangePopupText),
                status: 'info',
                icon: 'mi-info',
                confirmButtonText: messages.ownRepairReasonChangePopupBtn
            }).catch(_.noop);
        }
        _.set(claimVM.value, path, value);
        updateWizardData(claimVM);
    };

    const getSkipButtonType = () => {
        const ownRepairerSkipDetails = _.get(
            claimVM.value,
            'lobs.commercialAuto.repairOption.ownRepairer.userSkipsOwnRepairerDetails'
        );
        if (!ownRepairerSkipDetails) {
            return 'outlined';
        }
        return 'filled';
    };

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showOptional: false
        },
        postCodeLookupButton: {
            visible: isUnitedKingdomChosen(),
            disabled: isPostCodeValid()
        },
        skipButton: {
            type: getSkipButtonType()
        },
        reasonForApprovalRadioButton: {
            defaultValue: 'fleetProvider',
            value: _.get(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.reasonForApproval')

        },
        repairFacilityName: {
            value: _.get(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.nameOfOwnRepairer')
        },
        PostcodeInlineLoader: {
            loading: showPostCodeLoader,
            loadingMessage: 'Fetching address...',
            visible: showPostCodeLoader
        },
        LossLocationOnPostcode: {
            label: 'Addresses for ' + _.get(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.address.postalCode'),
            visible: showLookupResult_Ext && !isPostCodeValid(),
            availableValues: getMultipleLookupResult(),
            onValueChange: (addressIndex) => {
                handlePostCodeAddressDropDownValueChange(addressIndex);
            }
        },
        postCode: {
            visible: isUnitedKingdomChosen(),
            value: _.get(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.address.postalCode')
        },
        addressLineOne: {
            value: _.get(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.address.addressLine1')
        },
        addressLineTwo: {
            value: _.get(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.address.addressLine2')
        },
        addressLineThree: {
            value: _.get(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.address.addressLine3')
        },
        city: {
            value: _.get(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.address.city')
        },
        country: {
            defaultValue: 'GB',
            value: _.get(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.address.country')
        },
        phoneNumber: {
            value: _.get(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.phoneNumber')
        },
        email: {
            value: _.get(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.emailAddress')
        },
        engineerNote: {
            value: _.get(claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.noteForEngineer')
        }

    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            lookupClick: lookupClick,
            handleOwnRepairerSkip: handleOwnRepairerSkip,
            handleOwnRepairerValueChange: handleOwnRepairerValueChange
        }
    };

    const shouldPageSkip = useCallback(() => {
        const skipOwnRepairer = _.get(
            claimVM.value, 'lobs.commercialAuto.repairOption.ownRepairer.nameOfOwnRepairer'
        );
        return skipOwnRepairer;
    }, [claimVM]);

    useEffect(() => {
        registerInitialComponentValidation(shouldPageSkip);
    }, [registerInitialComponentValidation, shouldPageSkip]);

    return (
        <WizardPage
            skipWhen={initialValidation}
            disableNext={!(isComponentValid || (getSkipButtonType() === 'filled'))}
            template={WizardPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

FNOLCARepairFacilityPage.propTypes = wizardProps;
export default FNOLCARepairFacilityPage;
